import React from 'react';

import C from '../C';
import DataStore from '../base/plumbing/DataStore';
import ActionMan from '../plumbing/ActionMan';
// import ChartWidget from './ChartWidget';
import TrafficReport from './TrafficReport';
import {setTaskTags} from '../base/components/TaskList';
import ServerIO from '../plumbing/ServerIO';

function DashboardPage() {
	setTaskTags();
	// display...
	return (
		<div className="page DashboardPage">
			<EndpointSwitcher />
			<TrafficReport />
		</div>
	);
} // ./DashboardPage


/**
 * For testing, allow switching endpoint
 */
function EndpointSwitcher() {
	if (C.isProduction()) return null;
	return <p>DataLog Endpoint: {ServerIO.DATALOG_ENDPOINT} 
		<SwitchButton url="https://lg.good-loop.com/data" label="live" />
		<SwitchButton url="https://testlg.good-loop.com/data" label="test" />
		<SwitchButton url="https://locallg.good-loop.com/data" label="local" />
	</p>;
}

function SwitchButton({url,label}) {
	return (<button type="button" onClick={e => {
		ServerIO.DATALOG_ENDPOINT = url;
		DataStore.setValue(['widget', 'TrafficReport'], null);
	}} className="btn btn-xs ml-1">{label}</button>);
}

export default DashboardPage;
